import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * 로딩 스피너.
 * - 기본(버튼 내장형): 글자 크기(1em)·currentColor를 따라 텍스트 옆에 인라인 배치
 * - area: 영역형 — 컨테이너 안에서 세로 중앙 정렬 + 안내 문구
 */
@Component({
  selector: 'pk-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pk-spinner__ring"></span>
    @if (label(); as text) {
      <span class="pk-spinner__label">{{ text }}</span>
    }
  `,
  host: {
    role: 'status',
    '[class.pk-spinner--area]': 'area()',
    '[attr.aria-label]': 'label() ?? "로딩 중"',
  },
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      gap: var(--pk-space-2);
      color: inherit;
    }

    .pk-spinner__ring {
      display: inline-block;
      width: 1em;
      height: 1em;
      border: 2px solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      animation: pk-spin 0.7s linear infinite;
      flex-shrink: 0;
    }

    :host(.pk-spinner--area) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: var(--pk-space-6);
      color: var(--pk-text-muted);
      font-size: 13px;

      .pk-spinner__ring {
        width: 26px;
        height: 26px;
        border-width: 3px;
        color: var(--pk-green);
      }
    }

    @keyframes pk-spin {
      to {
        transform: rotate(360deg);
      }
    }
  `,
})
export class PkSpinner {
  /** 영역형 (중앙 정렬 + 큰 링) */
  readonly area = input(false);
  readonly label = input<string | null>(null);
}
